import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultTinyUrlPage from './Pages/DefaultTinyUrlPage';
import WizardPage from './Pages/WizardPage';

const TinyUrlRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:tinyUrlId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultTinyUrlPage />
            </Route>
        </Switch>
    );
};

export default TinyUrlRouter;
